<template>
<div :ref="loadingobj">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">编辑分类</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="list.length > 1 ? list.length : ''" class="item">
        <wcbutton :option="{title:'提交数据'}" @finish="submitData"/>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <wcbutton :option="{title:'返回分类管理',type:'del'}" @finish="$parent.JUMPVIEW({name:'EsCates'})"/>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in list" :key="index">
            <div class="TTL-form-submit-box-title">分类-{{index+1}}</div>
            <el-form :inline="false" style="margin-top:20px">
                <el-form-item>
                    <wcupload :option="{size:'large'}" 
                        :value="item.thumb" 
                        @finish="(val)=> {
                            item.thumb=val.url;
                        }" 
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">一级分类</label>
                    <wcselect :option="{placeholder:'请选择一级分类',filterable:true,clearable:true,ischange:true,width:'250px'}" 
                        :value="item.pid" 
                        :list="catelists"
                        @finish="(val)=> {
                            if(val.type=='change') {
                                item.pid=val.value;
                                item.pname=val.valuename;
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">分类名称<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入分类名称',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.name"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.name=val.value;
                            }
                            if(val.type=='change') {
                                item.name=val.value;
                            }
                        }"
                    />
                </el-form-item>

            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_CATE from '@/Interface/Es/Goods/Cates';
export default {
    components:{},
    data() {
        return {
            loadingobj:'editcate',
            limit:10,  //限制添加数据条数          
            list:[], //数据
            catelists:[], //一级分类
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetParentCates(isfresh); //获取一级分类信息列表
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                this.$confirm.confirm(
                    '当前有数据正在执行编辑操作，是否要执行覆盖操作 ？',
                    '操作提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}).then(()=> {
                    this.GetCateInfo(data.param.ids);
                }).catch(()=> {
                    
                });
            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }else {
                this.GetCateInfo(data.param.ids);
            }
        },


        /** 保存模板信息 **/
        submitData() {
            if(this.list.length==0) {this.$notice({title:'错误提示',message:'请至少填写一个品牌',type:'warning'});return false;}
            var data=[];
            for(var i in this.list) data.push(this.list[i]);
            data=JSON.stringify(data);

            var obj=this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_CATE.EDIT_CATES({data:data}).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                this.$parent.JUMPVIEW({name:'EsCates',delname:'EsEditCates'});
            });
        },


        /** 查看分类信息 **/
        GetCateInfo(ids) {
            var obj=this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_CATE.CATES_INFO({ids:ids}).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                this.list=res.data;
            });
        },


        /** 获取品牌信息列表 **/
        GetParentCates(isfresh) {
            this.$method.GET_CATES_PARENT(isfresh).then((res) => {this.catelists=res;console.log(res)});
        },


    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:100px;height:100px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
::v-deep(.imagefile .el-image__inner) {width:50% !important;height: 50% !important;}

.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.petTitle {padding:30px 0 20px 0;}
.TTL-photos {display:inline-block;width:100%;font-size:0;}
.TTL-photos-infos {display:inline-block;width:100px;height:100px;margin-right:10px;margin-bottom:10px;background-color:#e6e7ec;border-radius: 15px;overflow:hidden;position:relative;}
.TTL-photos-infos .el-image {width:100%;height:100%;}
.TTL-photos-del {width:25px;height:25px;position: absolute;top:0;right:0;margin-top:5px;margin-right:5px;border-radius: 50%;background-color: rgba(0,0,0,1);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/close.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.default-photos {background-image:url(@/assets/icon/default-img.png);background-repeat: no-repeat;background-size: 65%;background-position: center;cursor: pointer;}
.TTL-photos-select {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:#666eeb;display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-photos-select-no {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:rgba(221,221,221,.6);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-form-label i {font-style:normal;color:red;font-size:12px;font-weight: 400;}
.fileup {background-color: #666eeb !important;}
::v-deep(.fileup .el-image__inner) {width:80% !important;height: 80% !important;}
</style>